// extracted by mini-css-extract-plugin
export default {"list":"CheckmarkList_list__E2Ye8","item":"CheckmarkList_item__LsiMY","checkmark":"CheckmarkList_checkmark__xkTn2"};